import { useAtomValue, useSetAtom } from '~shared/lib/atom-state';

import {
  parentNotificationHistoryAtom,
  parentNotificationHistoryLoadingAtom,
  parentNotificationUnreadCountAtom,
  refetchParentNotificationUnreadCountAtom,
  setParentNotificationHistoryAtom,
} from './atoms';

export const useParentNotificationHistory = () => useAtomValue(parentNotificationHistoryAtom);
export const useParentNotificationHistoryLoading = () =>
  useAtomValue(parentNotificationHistoryLoadingAtom);
export const useSetParentNotificationHistory = () => useSetAtom(setParentNotificationHistoryAtom);

export const useParentNotificationUnreadCount = () =>
  useAtomValue(parentNotificationUnreadCountAtom);
export const useRefetchParentNotificationUnreadCount = () =>
  useSetAtom(refetchParentNotificationUnreadCountAtom);
